import { render, staticRenderFns } from "./translate-list.vue?vue&type=template&id=5b0c3bdb&scoped=true&"
import script from "./translate-list.vue?vue&type=script&lang=ts&"
export * from "./translate-list.vue?vue&type=script&lang=ts&"
import style0 from "./translate-list.vue?vue&type=style&index=0&id=5b0c3bdb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0c3bdb",
  null
  
)

export default component.exports